(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_0f48dfb"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('celonique-academy-loop-v2')) {
  customElements.define('celonique-academy-loop-v2', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.mobile = matchMedia('(max-width: 989px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.update = () => { this.sync(); this.crop(); };
      this.resizeObserver = new ResizeObserver(() => this.crop());
      this.querySelectorAll('[data-variant]').forEach(frame => this.resizeObserver.observe(frame));
      this.querySelectorAll('img').forEach(image => image.addEventListener('load', () => this.crop(), {signal:this.abort.signal}));
      this.crop();
      this.mobile.addEventListener('change', this.update);
      this.reduced.addEventListener('change', this.update);
      document.addEventListener('visibilitychange', this.update, {signal:this.abort.signal});
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting; this.sync();
      });
      this.observer.observe(this);
    }
    crop() {
      const properties = ['width', 'height', 'min-width', 'max-width', 'min-height', 'max-height', 'left', 'right', 'top', 'bottom', 'transform', 'aspect-ratio', 'object-fit', 'position', 'margin'];
      this.querySelectorAll('[data-variant]').forEach(frame => {
        frame.querySelectorAll(':scope > img, :scope > video').forEach(asset => {
          if (!this.mobile.matches || frame.dataset.variant !== 'mobile') {
            properties.forEach(property => asset.style.removeProperty(property));
            return;
          }
          const width = frame.clientWidth;
          const height = frame.clientHeight;
          if (!width || !height) return;
          const film = asset.tagName === 'VIDEO';
          const style = getComputedStyle(frame);
          const prefix = film ? '--film-' : '--poster-';
          const intrinsicWidth = film ? asset.videoWidth : asset.naturalWidth;
          const intrinsicHeight = film ? asset.videoHeight : asset.naturalHeight;
          const ratio = intrinsicWidth && intrinsicHeight ? intrinsicWidth / intrinsicHeight : Number.parseFloat(style.getPropertyValue(prefix + 'ratio')) || 1.5;
          const focusValue = Number.parseFloat(style.getPropertyValue(prefix + 'focus'));
          const focus = Number.isFinite(focusValue) ? Math.min(100, Math.max(0, focusValue)) / 100 : 0.8;
          const zoom = Math.max(1, Number.parseFloat(style.getPropertyValue(prefix + 'zoom')) || 1);
          const renderedWidth = Math.max(width, height * ratio) * zoom;
          const renderedHeight = renderedWidth / ratio;
          const values = {
            position: 'absolute', width: renderedWidth + 'px', height: renderedHeight + 'px',
            'min-width': '0', 'max-width': 'none', 'min-height': '0', 'max-height': 'none',
            left: (width / 2 - renderedWidth * focus) + 'px', right: 'auto',
            top: (height - renderedHeight) / 2 + 'px', bottom: 'auto',
            transform: 'none', 'aspect-ratio': 'auto', 'object-fit': 'fill', margin: '0'
          };
          Object.entries(values).forEach(([property, value]) => asset.style.setProperty(property, value, 'important'));
        });
      });
    }
    sync() {
      const active = this.mobile.matches ? 'mobile' : 'desktop';
      this.querySelectorAll('[data-variant]').forEach(frame => {
        const play = frame.dataset.variant === active && this.visible && !document.hidden && !this.reduced.matches;
        let video = frame.querySelector('video');
        if (play && !video && frame.querySelector('template')) {
          frame.append(frame.querySelector('template').content.cloneNode(true));
          video = frame.querySelector('video');
          video.addEventListener('loadedmetadata', () => this.crop(), {signal:this.abort.signal});
          video.addEventListener('loadeddata', () => this.crop(), {signal:this.abort.signal});
          this.crop();
          video.muted = true;
          video.defaultMuted = true;
          video.removeAttribute('controls');
          video.addEventListener('playing', () => {
            if (this.reduced.matches || document.hidden || !this.visible || frame.dataset.variant !== (this.mobile.matches ? 'mobile' : 'desktop')) {
              video.pause(); return;
            }
            this.crop();
            video.classList.add('is-playing');
          }, {signal:this.abort.signal});
          video.addEventListener('error', () => video.classList.remove('is-playing'), {signal:this.abort.signal});
        }
        if (!video) return;
        if (play) {
          const attempt = video.play();
          if (attempt) attempt.catch(() => video.classList.remove('is-playing'));
        } else {
          video.pause();
          if (this.reduced.matches) video.classList.remove('is-playing');
        }
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.abort?.abort();
      this.mobile?.removeEventListener('change', this.update);
      this.reduced?.removeEventListener('change', this.update);
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_33161a0"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('celonique-five-motion'))customElements.define('celonique-five-motion',class extends HTMLElement{
connectedCallback(){this.frame=requestAnimationFrame(()=>this.init());}
init(){if(!this.isConnected)return;this.abort=new AbortController();const options={signal:this.abort.signal};this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.videos=[...this.querySelectorAll('video')];this.visible=new Set();this.observer=new IntersectionObserver(entries=>{for(const e of entries){if(e.isIntersecting)this.visible.add(e.target);else this.visible.delete(e.target);}this.sync();});for(const v of this.videos){v.muted=true;v.defaultMuted=true;v.controls=false;v.loop=true;v.playsInline=true;v.disablePictureInPicture=true;v.setAttribute('aria-hidden','true');v.setAttribute('tabindex','-1');v.addEventListener('playing',()=>{if(this.motion.matches||document.hidden||!this.visible.has(v)){v.pause();return;}v.classList.add('is-playing');},options);v.addEventListener('error',()=>v.classList.remove('is-playing'),options);this.observer.observe(v);}this.motion.addEventListener('change',()=>this.sync(),options);document.addEventListener('visibilitychange',()=>this.sync(),options);}
sync(){for(const v of this.videos){if(this.motion.matches){v.pause();v.classList.remove('is-playing');}else if(this.visible.has(v)&&!document.hidden){v.play()?.catch(()=>v.classList.remove('is-playing'));}else v.pause();}}
disconnectedCallback(){cancelAnimationFrame(this.frame);this.abort?.abort();this.observer?.disconnect();this.videos?.forEach(v=>v.pause());}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_68e7a1c"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('celonique-exosomes-loop')) {
  customElements.define('celonique-exosomes-loop', class extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-stage]');
      if (!this.stage) return;
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.fitLayout = () => {
        cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(() => {
          const content = this.querySelector('[class$="__content"]');
          const caption = this.querySelector('figcaption');
          const viewport = window.innerHeight;
          const top = Math.max(0, Math.min(this.getBoundingClientRect().top + window.scrollY, viewport * 0.4));
          const style = getComputedStyle(this);
          const gap = parseFloat(style.getPropertyValue('--media-gap')) || 0;
          const bottom = parseFloat(style.getPropertyValue('--media-bottom')) || 0;
          const remaining = viewport - top - (content?.offsetHeight || 0) - (caption?.offsetHeight || 0) - gap - bottom - 22;
          const limit = Number(this.mobile.matches ? this.dataset.mobileHeight : this.dataset.desktopHeight);
          this.style.setProperty('--media-height', Math.min(limit, Math.max(180, remaining)) + 'px');
        });
      };
      this.layoutObserver = new ResizeObserver(this.fitLayout);
      const content = this.querySelector('[class$="__content"]');
      if (content) this.layoutObserver.observe(content);
      window.addEventListener('resize', this.fitLayout);
      this.fitLayout();
      this.update = () => this.selectVideo();
      this.visibility = () => this.playback();
      this.mobile.addEventListener('change', this.update);
      this.reduced.addEventListener('change', this.update);
      document.addEventListener('visibilitychange', this.visibility);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.selectVideo();
        else this.playback();
      }, {threshold: 0.05});
      this.observer.observe(this.stage);
    }
    clearVideo() {
      if (!this.video) return;
      this.video.pause();
      this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
      this.video.removeAttribute('src');
      this.video.load();
      this.video.remove();
      this.video = null;
      this.key = null;
    }
    selectVideo() {
      if (this.reduced.matches) { this.clearVideo(); return; }
      if (!this.visible) return;
      const key = this.mobile.matches ? 'mobile' : 'desktop';
      if (key !== this.key) {
        this.clearVideo();
        const template = this.querySelector(`template[data-video="${key}"]`);
        if (!template) return;
        const video = template.content.querySelector('video').cloneNode(true);
        if (!video.querySelector('source')) return;
        this.video = video;
        this.key = key;
        video.muted = true;
        video.defaultMuted = true;
        video.addEventListener('playing', () => {
          if (!this.visible || document.hidden || this.reduced.matches) { video.pause(); return; }
          video.setAttribute('data-playing', '');
        });
        video.addEventListener('error', () => video.removeAttribute('data-playing'));
        this.stage.append(video);
      }
      this.playback();
    }
    playback() {
      const video = this.video;
      if (!video) return;
      if (!this.visible || document.hidden || this.reduced.matches) { video.pause(); return; }
      const promise = video.play();
      if (promise) promise.catch(() => video.removeAttribute('data-playing'));
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.layoutObserver?.disconnect();
      window.removeEventListener('resize', this.fitLayout);
      cancelAnimationFrame(this.layoutFrame);
      this.mobile?.removeEventListener('change', this.update);
      this.reduced?.removeEventListener('change', this.update);
      document.removeEventListener('visibilitychange', this.visibility);
      this.clearVideo();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_9ae06a4"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('celonique-editorial-hero-v4')) {
  customElements.define('celonique-editorial-hero-v4', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected || this.abort) return;
      this.mediaSlot = this.querySelector('[data-video-slot]');
      if (!this.mediaSlot) {
        this.initFrame = requestAnimationFrame(() => this.initialize());
        return;
      }
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.mobile = matchMedia('(max-width: 999px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.visible = true;
      this.generation = 0;

      this.mobile.addEventListener('change', () => this.refresh(), options);
      this.motion.addEventListener('change', () => this.refresh(), options);
      document.addEventListener('visibilitychange', () => this.resumeOrPause(), options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.resumeOrPause();
      });
      this.observer.observe(this);
      this.refresh();
    }
    clearVideo() {
      this.generation++;
      this.pendingPlay = null;
      this.mediaAbort?.abort();
      if (this.video) {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.querySelectorAll('source').forEach(s => s.remove());
        this.video.load();
      }
      this.video = null;
      this.mediaSlot?.replaceChildren();

    }
    refresh() {
      this.clearVideo();
      const error = this.querySelector('[data-video-error]');
      if (error) error.hidden = true;
      if (this.dataset.mode !== 'video' || this.motion.matches) return;
      const template = this.querySelector(this.mobile.matches ? '[data-mobile-video]' : '[data-desktop-video]');
      const original = template?.content.querySelector('video');
      if (!original) return;
      const video = original.cloneNode(true);
      this.video = video;
      this.mediaAbort = new AbortController();
      const options = {signal: this.mediaAbort.signal};
      video.controls = false;
      video.disablePictureInPicture = true;
      video.disableRemotePlayback = true;
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('aria-hidden', 'true');
      video.setAttribute('tabindex', '-1');
      video.preload = 'auto';
      video.removeAttribute('autoplay');
      const sources = Array.from(video.querySelectorAll('source'));
      const mp4 = sources.find(s => s.type === 'video/mp4');
      if (mp4) sources.forEach(s => { if (s !== mp4) s.remove(); });
      video.addEventListener('playing', () => {
        if (this.video !== video) return;
        if (this.motion.matches || this.userPaused || document.hidden || !this.visible) { video.pause(); return; }
        video.classList.add('is-ready');
        this.setButton(true);
      }, options);
      video.addEventListener('pause', () => { if (this.video === video) this.setButton(false); }, options);
      video.addEventListener('error', () => {
        if (this.video !== video) return;
        video.classList.remove('is-ready');

        if (error) error.hidden = false;
      }, options);
      this.mediaSlot.append(video);
      this.setButton(false);
      video.load();
      this.resumeOrPause();
    }
    setButton() {}
    resumeOrPause() {
      if (!this.video) return;
      if (this.visible && !document.hidden && !this.userPaused && !this.motion.matches) this.requestPlay();
      else this.video.pause();
    }
    requestPlay() {
      const video = this.video;
      if (!video || this.pendingPlay || this.motion.matches) return;
      const generation = this.generation;
      const attempt = video.play();
      if (!attempt) return;
      this.pendingPlay = attempt;
      attempt.catch(error => {
        if (this.video !== video || generation !== this.generation) return;
        if (error.name === 'AbortError') return;
        video.classList.remove('is-ready');
        this.setButton(false);
      }).finally(() => {
        if (this.pendingPlay === attempt) this.pendingPlay = null;
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
      this.clearVideo();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_d15c07a"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('celonique-science-motion')) {
  customElements.define('celonique-science-motion', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.frame = this.video.parentElement;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.wantsPlay = this.dataset.autoplay === 'true' && !this.motion.matches;
      this.visible = false;
      this.video.muted = true;
      this.video.playsInline = true;
      this.video.controls = false;
      this.video.removeAttribute('controls');
      this.video.disablePictureInPicture = true;
      this.video.setAttribute('aria-hidden', 'true');
      this.video.setAttribute('tabindex', '-1');
      this.video.addEventListener('error', () => {
        this.wantsPlay = false;
        this.frame.setAttribute('data-failed', '');
      }, options);
      this.motion.addEventListener('change', () => {
        this.wantsPlay = this.dataset.autoplay === 'true' && !this.motion.matches;
        this.sync();
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      }, { threshold: 0.15 });
      this.observer.observe(this.frame);
    }
    sync() {
      if (this.wantsPlay && this.visible && !document.hidden) {
        this.video.play().catch(error => {
          if (error.name === 'AbortError' || !this.visible || document.hidden) return;
          this.wantsPlay = false;
        });
      } else {
        this.video.pause();
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.video?.pause();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_dac8819"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('celonique-peptides-loop')) {
  customElements.define('celonique-peptides-loop', class extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-stage]');
      if (!this.stage) return;
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.fitLayout = () => {
        cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(() => {
          const content = this.querySelector('[class$="__content"]');
          const caption = this.querySelector('figcaption');
          const viewport = window.innerHeight;
          const top = Math.max(0, Math.min(this.getBoundingClientRect().top + window.scrollY, viewport * 0.4));
          const style = getComputedStyle(this);
          const gap = parseFloat(style.getPropertyValue('--media-gap')) || 0;
          const bottom = parseFloat(style.getPropertyValue('--media-bottom')) || 0;
          const remaining = viewport - top - (content?.offsetHeight || 0) - (caption?.offsetHeight || 0) - gap - bottom - 22;
          const limit = Number(this.mobile.matches ? this.dataset.mobileHeight : this.dataset.desktopHeight);
          this.style.setProperty('--media-height', Math.min(limit, Math.max(180, remaining)) + 'px');
        });
      };
      this.layoutObserver = new ResizeObserver(this.fitLayout);
      const content = this.querySelector('[class$="__content"]');
      if (content) this.layoutObserver.observe(content);
      window.addEventListener('resize', this.fitLayout);
      this.fitLayout();
      this.update = () => this.selectVideo();
      this.visibility = () => this.playback();
      this.mobile.addEventListener('change', this.update);
      this.reduced.addEventListener('change', this.update);
      document.addEventListener('visibilitychange', this.visibility);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.selectVideo();
        else this.playback();
      }, {threshold: 0.05});
      this.observer.observe(this.stage);
    }
    clearVideo() {
      if (!this.video) return;
      this.video.pause();
      this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
      this.video.removeAttribute('src');
      this.video.load();
      this.video.remove();
      this.video = null;
      this.key = null;
    }
    selectVideo() {
      if (this.reduced.matches) { this.clearVideo(); return; }
      if (!this.visible) return;
      const key = this.mobile.matches ? 'mobile' : 'desktop';
      if (key !== this.key) {
        this.clearVideo();
        const template = this.querySelector(`template[data-video="${key}"]`);
        if (!template) return;
        const video = template.content.querySelector('video').cloneNode(true);
        if (!video.querySelector('source')) return;
        this.video = video;
        this.key = key;
        video.muted = true;
        video.defaultMuted = true;
        video.addEventListener('playing', () => {
          if (!this.visible || document.hidden || this.reduced.matches) { video.pause(); return; }
          video.setAttribute('data-playing', '');
        });
        video.addEventListener('error', () => video.removeAttribute('data-playing'));
        this.stage.append(video);
      }
      this.playback();
    }
    playback() {
      const video = this.video;
      if (!video) return;
      if (!this.visible || document.hidden || this.reduced.matches) { video.pause(); return; }
      const promise = video.play();
      if (promise) promise.catch(() => video.removeAttribute('data-playing'));
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.layoutObserver?.disconnect();
      window.removeEventListener('resize', this.fitLayout);
      cancelAnimationFrame(this.layoutFrame);
      this.mobile?.removeEventListener('change', this.update);
      this.reduced?.removeEventListener('change', this.update);
      document.removeEventListener('visibilitychange', this.visibility);
      this.clearVideo();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_f6c3bed"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('celonique-retinoids-loop')) {
  customElements.define('celonique-retinoids-loop', class extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-stage]');
      if (!this.stage) return;
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.fitLayout = () => {
        cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(() => {
          const content = this.querySelector('[class$="__content"]');
          const caption = this.querySelector('figcaption');
          const viewport = window.innerHeight;
          const top = Math.max(0, Math.min(this.getBoundingClientRect().top + window.scrollY, viewport * 0.4));
          const style = getComputedStyle(this);
          const gap = parseFloat(style.getPropertyValue('--media-gap')) || 0;
          const bottom = parseFloat(style.getPropertyValue('--media-bottom')) || 0;
          const remaining = viewport - top - (content?.offsetHeight || 0) - (caption?.offsetHeight || 0) - gap - bottom - 22;
          const limit = Number(this.mobile.matches ? this.dataset.mobileHeight : this.dataset.desktopHeight);
          this.style.setProperty('--media-height', Math.min(limit, Math.max(180, remaining)) + 'px');
        });
      };
      this.layoutObserver = new ResizeObserver(this.fitLayout);
      const content = this.querySelector('[class$="__content"]');
      if (content) this.layoutObserver.observe(content);
      window.addEventListener('resize', this.fitLayout);
      this.fitLayout();
      this.update = () => this.selectVideo();
      this.visibility = () => this.playback();
      this.mobile.addEventListener('change', this.update);
      this.reduced.addEventListener('change', this.update);
      document.addEventListener('visibilitychange', this.visibility);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.selectVideo();
        else this.playback();
      }, {threshold: 0.05});
      this.observer.observe(this.stage);
    }
    clearVideo() {
      if (!this.video) return;
      this.video.pause();
      this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
      this.video.removeAttribute('src');
      this.video.load();
      this.video.remove();
      this.video = null;
      this.key = null;
    }
    selectVideo() {
      if (this.reduced.matches) { this.clearVideo(); return; }
      if (!this.visible) return;
      const key = this.mobile.matches ? 'mobile' : 'desktop';
      if (key !== this.key) {
        this.clearVideo();
        const template = this.querySelector(`template[data-video="${key}"]`);
        if (!template) return;
        const video = template.content.querySelector('video').cloneNode(true);
        if (!video.querySelector('source')) return;
        this.video = video;
        this.key = key;
        video.muted = true;
        video.defaultMuted = true;
        video.addEventListener('playing', () => {
          if (!this.visible || document.hidden || this.reduced.matches) { video.pause(); return; }
          video.setAttribute('data-playing', '');
        });
        video.addEventListener('error', () => video.removeAttribute('data-playing'));
        this.stage.append(video);
      }
      this.playback();
    }
    playback() {
      const video = this.video;
      if (!video) return;
      if (!this.visible || document.hidden || this.reduced.matches) { video.pause(); return; }
      const promise = video.play();
      if (promise) promise.catch(() => video.removeAttribute('data-playing'));
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.layoutObserver?.disconnect();
      window.removeEventListener('resize', this.fitLayout);
      cancelAnimationFrame(this.layoutFrame);
      this.mobile?.removeEventListener('change', this.update);
      this.reduced?.removeEventListener('change', this.update);
      document.removeEventListener('visibilitychange', this.visibility);
      this.clearVideo();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
